<template>
  <div>
    <PmNoRealTaskQueryList ref='PmNoRealTaskQueryList' @noRealQueryListPageClick="noRealQueryListPageClick" :dataOfNoRealTaskQueryList="dataOfNoRealTaskQueryList" :selectedCounterNode="selectedCounterNode"></PmNoRealTaskQueryList>

    <!-- 非实时数据查询搜索第一步弹出框 -->
    <CustomDialog ref='NoRealTaskDataQueryDialog' :element='NoRealTaskDataQueryDialog.element' :styles='NoRealTaskDataQueryDialog.style'>
      <template v-slot:dialog-content>
        <NoRealTaskDataQueryDialog ref="NoRealTaskDataQuery" :selectNeId="selectNeId" :selectNeType="selectNeType"></NoRealTaskDataQueryDialog>
      </template>
    </CustomDialog>

    <CustomDialog ref='NoRealTaskDataExportDialog' :element='NoRealTaskDataExportDialog.element' :styles='NoRealTaskDataExportDialog.style'>
      <template v-slot:dialog-content>
        <NoRealTaskDataExportDialog ref="NoRealTaskDataExport" :selectNeId="selectNeId" :selectNeType="selectNeType"></NoRealTaskDataExportDialog>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import PmNoRealTaskQueryList from './PmNoRealTaskQueryList';
  import CustomDialog from '../../../../common/CustomDialog';
  import NoRealTaskDataQueryDialog from './dialog/NoRealTaskDataQueryDialog';
  import NoRealTaskDataExportDialog from './dialog/NoRealTaskDataExportDialog';
  import DateUtil from "../../../util/DateUtil";
  import CommonUtil from "../../../util/CommonUtil";
  import {EventBus} from "../../../../../plugins/eventBus";

  export default {
    name: 'PmNoRealDataQueryRightList',
    props: [
      'selectNeId',
      'selectNeType'
    ],
    components: {
      PmNoRealTaskQueryList,
      CustomDialog,
      NoRealTaskDataQueryDialog,
      NoRealTaskDataExportDialog
    },
    data() {
      return {
        NoRealTaskDataQueryDialog: {
          style: {
            width: '800px',
            height: '760px',
            visible: false,
            model: true
          },
          element: {
            title: `${this.$t('Pm.queryInfo')}`,
            target: this.$refs.PmNoRealTaskQueryList,
            refName: 'NoRealTaskDataQueryDialogElement',
            buttonGroup: [
              { click: this.closeNoRealTaskDataQueryDialog, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.noRealTaskDataQueryBegin, buttonModel: { content: this.$t('Pm.query'), isPrimary: true }},
            ],
            isClose: true
          }
        },
        NoRealTaskDataExportDialog: {
          style: {
            width: '800px',
            height: '760px',
            visible: false,
            model: true
          },
          element: {
            title: this.$t('Pm.export'),
            target: this.$refs.PmNoRealTaskQueryList,
            refName: 'NoRealTaskDataExportDialogElement',
            buttonGroup: [
              { click: this.closeNoRealTaskDataExportDialog, buttonModel: { content: this.$t('Common.cancel') } },
              { click: this.noRealTaskDataExportBegin, buttonModel: { content: this.$t('Pm.export'), isPrimary: true } },
            ],
            isClose: true
          }
        },
        page: {
          pageNo: 1,
          pageSize: 20
        },
        selectedCounterNode: [],
        dataOfNoRealTaskQueryList: [],
        startTime: '',
        endTime: '',
        measureObjCode: '',
        sampleTime: '',
        nodeCheckList: [],
        nodeCheckIdList: []
      };
    },
    methods: {
      noRealQueryListPageClick(currentPage){
        this.$axios.post('/lte/ems/pm/noReal/query/getQueryData.html', {
          startTime: this.startTime,
          endTime: this.endTime,
          measureObjCode: this.measureObjCode,
          sampleTime: this.sampleTime,
          nodeCheckList: this.nodeCheckIdList,
          neId: this.selectNeId,
          neTypeCode: this.selectNeType,
          page: {
            pageNo: currentPage,
            pageSize: 20
          }
        }).then((response) => {
          const result = response.data.resultVal.result;
          if (result.length != 0) {
            this.dataOfNoRealTaskQueryList = result;
            this.$refs.PmNoRealTaskQueryList.page.totalRecordsCount = response.data.resultVal.totalCount;
            this.$refs.PmNoRealTaskQueryList.page.currentPage = response.data.resultVal.pageNo;
          } else {
            this.dataOfNoRealTaskQueryList = [];
            this.$refs.PmNoRealTaskQueryList.page.totalRecordsCount = 0;
            this.$refs.PmNoRealTaskQueryList.page.currentPage = 1;
          }
          this.$refs.PmNoRealTaskQueryList.dataSource = this.dataOfNoRealTaskQueryList;
          this.$loading.hideLoadding();
        });
        this.$refs.NoRealTaskDataQueryDialog.close();
      },

      closeNoRealTaskDataQueryDialog() {
        this.$refs.NoRealTaskDataQueryDialog.clear();
        this.$refs.NoRealTaskDataQueryDialog.close();
      },
      closeNoRealTaskDataExportDialog() {
        this.$refs.NoRealTaskDataExportDialog.clear();
        this.$refs.NoRealTaskDataExportDialog.close();
      },
      pmNoRealTaskDataQuery(){
        this.$refs.NoRealTaskDataQuery.bindValidateOfNoRealDataQuery();
        this.$refs.NoRealTaskDataQuery.getMeasureListForDataQuery(this.selectNeId,this.selectNeType);
        this.$refs.NoRealTaskDataQueryDialog.show();
      },
      pmNoRealTaskDataExport(){
        this.$refs.NoRealTaskDataExport.bindValidateOfNoRealDataExport();
        this.$refs.NoRealTaskDataExport.getMeasureListForDataExport(this.selectNeId,this.selectNeType);
        this.$refs.NoRealTaskDataExportDialog.show();
      },
      noRealTaskDataQueryBegin(){
        const ruleDatas = this.$refs.NoRealTaskDataQuery.validateOfNoRealDataQuery();
        if (!ruleDatas) {
          return;
        }
        this.startTime = DateUtil.getDateString(this.$refs.NoRealTaskDataQuery.startTime);
        this.endTime = DateUtil.getDateString(this.$refs.NoRealTaskDataQuery.endTime);
        this.measureObjCode = this.$refs.NoRealTaskDataQuery.measureObjCode;
        this.sampleTime = this.$refs.NoRealTaskDataQuery.sampleTime.toString();
        this.nodeCheckIdList =  this.$refs.NoRealTaskDataQuery.$refs.NoRealTaskMeasureTreeForDataSearch.nodeCheckIdList;
        if(this.nodeCheckIdList.length < 1) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.pleaseSelectCounter') });
          return;
        }
        this.selectedCounterNode = [];
        this.selectedCounterNode =  this.$refs.NoRealTaskDataQuery.$refs.NoRealTaskMeasureTreeForDataSearch.nodeCheckInfoList;
        this.$loading.showLoadding(this.$t('System.loading'));
        this.$axios.post('/lte/ems/pm/noReal/query/getQueryData.html', {
          startTime: this.startTime,
          endTime: this.endTime,
          measureObjCode: this.measureObjCode,
          sampleTime: this.sampleTime,
          nodeCheckList: this.nodeCheckIdList,
          neId: this.selectNeId,
          neTypeCode: this.selectNeType,
          page: {
            pageNo: 1,
            pageSize: 20
        }
        }).then((response) => {
          const result = response.data.resultVal.result;
          if (result.length != 0) {
            this.dataOfNoRealTaskQueryList = result;
            this.$refs.PmNoRealTaskQueryList.page.totalRecordsCount = response.data.resultVal.totalCount;
            this.$refs.PmNoRealTaskQueryList.page.currentPage = 1;
          } else {
            this.dataOfNoRealTaskQueryList = [];
            this.$refs.PmNoRealTaskQueryList.page.totalRecordsCount = 0;
            this.$refs.PmNoRealTaskQueryList.page.currentPage = 1;
          }
          this.$refs.PmNoRealTaskQueryList.dataSource = [];
          this.$refs.PmNoRealTaskQueryList.dataSource = this.dataOfNoRealTaskQueryList;

          this.$refs.PmNoRealTaskQueryList.getColumnsOfNoRealQueryList();
          this.$refs.PmNoRealTaskQueryList.$refs.noRealQueryList.refreshColumns();


          this.$loading.hideLoadding();
        });
        this.$refs.NoRealTaskDataQueryDialog.close();
      },

      noRealTaskDataExportBegin(){
        const ruleDatas = this.$refs.NoRealTaskDataExport.validateOfNoRealDataExport();
        if (!ruleDatas) {
          return;
        }
        let startTime = DateUtil.getDateString(this.$refs.NoRealTaskDataExport.startTime);
        let endTime = DateUtil.getDateString(this.$refs.NoRealTaskDataExport.endTime);
        let measureObjCode = this.$refs.NoRealTaskDataExport.measureObjCode;
        let sampleTime = this.$refs.NoRealTaskDataExport.sampleTime.toString();
        let nodeCheckList = this.$refs.NoRealTaskDataExport.$refs.NoRealTaskMeasureTreeForDataExport.nodeCheckIdList;
        let nodeCheckNameList = this.$refs.NoRealTaskDataExport.$refs.NoRealTaskMeasureTreeForDataExport.nodeCheckInfoList.map(function (nodeCheckInfo) {
          return nodeCheckInfo.text;
        });

        if(nodeCheckList.length < 1) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Pm.pleaseSelectCounter')});
          return;
        }

        this.$loading.showLoadding(this.$t('System.loading'));
        this.$axios.post('/lte/ems/pm/noReal/query/exportNoRealData.html', {
            startTime: startTime,
            endTime: endTime,
            measureObjCode: measureObjCode,
            sampleTime: sampleTime,
            nodeCheckList: nodeCheckList.join(),
            nodeCheckNameList: nodeCheckNameList.join(),
            neId: this.selectNeId,
            neTypeCode: this.selectNeType,
        },{
          responseType:'blob'
        }).then((response) => {
          const content = response.data;
          const blob = new Blob([content]);
          const fileName = 'result.xls';
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          this.$loading.hideLoadding();
        });

        this.$refs.NoRealTaskDataExportDialog.close();
      }
    },
    watch: {
    }
  };
</script>

<style>
</style>
